import { QueryClient } from "@tanstack/react-query";

/** Shared TanStack Query client for Rift payload orchestration. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "offlineFirst",
      gcTime: 15 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
